
export { CollectionName } from "/codebuild/output/src1235164992/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"